import React from 'react';
import SEO from '../components/SEO';
import { Sparkles, Target, Heart, Shield } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';

const About = () => {
  const { t, isBrazil } = useTranslation();
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title={`${isBrazil ? 'Sobre' : 'About'} - PlataPost`}
        description={t.aboutHeroSubtitle}
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-20 space-y-4">
          <p className="text-indigo-500 font-bold uppercase tracking-widest text-sm">
            {isBrazil ? "Sobre Nós" : "About Us"}
          </p>
          <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">
            {t.aboutHeroTitle.split(' ').slice(0, -1).join(' ')} <span className="text-indigo-500">{t.aboutHeroTitle.split(' ').slice(-1)}</span>
          </h1>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto font-medium">
            {t.aboutHeroSubtitle}
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-20 items-center mb-32">
          <div className="space-y-8">
            <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight tracking-tighter">{t.aboutSectionTitle}</h2>
            <div className="space-y-6 text-gray-400 text-lg leading-relaxed font-medium">
              <p>
                {t.aboutSectionP1}
              </p>
              <p>
                {t.aboutSectionP2}
              </p>
              <p>
                {t.aboutSectionP3}
              </p>
            </div>
          </div>
          <div className="glass-card rounded-[3.5rem] p-12 lg:p-20 relative overflow-hidden group border border-white/5 shadow-2xl shadow-indigo-600/5">
             <div className="absolute top-0 right-0 p-8 opacity-10 group-hover:scale-110 transition-transform">
               <Target className="w-64 h-64 text-indigo-400" />
             </div>
             <div className="relative space-y-12">
               <div className="flex items-center gap-6 group/item">
                 <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center text-white font-black text-xl shadow-lg shadow-indigo-600/20">1</div>
                 <h3 className="text-2xl font-black text-white tracking-tight">{t.aboutValue1}</h3>
               </div>
               <div className="flex items-center gap-6 group/item">
                 <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center text-white font-black text-xl shadow-lg shadow-indigo-600/20">2</div>
                 <h3 className="text-2xl font-black text-white tracking-tight">{t.aboutValue2}</h3>
               </div>
               <div className="flex items-center gap-6 group/item">
                 <div className="w-14 h-14 bg-indigo-600 rounded-2xl flex items-center justify-center text-white font-black text-xl shadow-lg shadow-indigo-600/20">3</div>
                 <h3 className="text-2xl font-black text-white tracking-tight">{t.aboutValue3}</h3>
               </div>
             </div>
          </div>
        </div>

        {/* Contact Info Preview */}
        <div className="glass-card rounded-[3.5rem] p-16 lg:p-24 text-center border border-white/5 relative overflow-hidden group">
          <div className="absolute inset-0 bg-gradient-to-t from-red-600/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
          <Heart className="w-16 h-16 text-red-500 mx-auto mb-8 animate-pulse" />
          <h2 className="text-3xl lg:text-5xl font-black text-white mb-6 tracking-tighter leading-tight">{t.aboutBuiltWithPassion.split('<br />')[0]} <br /> {t.aboutBuiltWithPassion.split('<br />')[1] || ''}</h2>
          <p className="text-gray-400 mb-10 text-xl font-medium">{t.aboutNeedToReachUs}</p>
          <a href="mailto:hello@platapost.com" className="text-2xl lg:text-4xl font-black text-indigo-400 hover:text-indigo-300 transition-colors tracking-tighter">
            hello@platapost.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default About;
